import { useMemo } from 'react';

import { useFormikContext } from 'formik';
import { useIntl } from 'react-intl';

import { getFiltersConfiguration } from 'app/modules/Invoices/config/filters';
import useDataTableContext from 'app/components/DataTable/context/DataTableContext';
import { GetSelectStructure } from 'app/hooks/usePaymentMethods.hook';

export const useFiltersConfiguration = () => {
  const intl = useIntl();
  const formik = useFormikContext();
  const {
    api: { apiResponse }
  } = useDataTableContext();
  const maxTotalAmount = useMemo(
    () => apiResponse?.meta?.maxTotalAmount || 0,
    [apiResponse?.meta?.maxTotalAmount]
  );

  const paymentMethods = GetSelectStructure();

  const completeConfiguration = useMemo(
    () =>
      getFiltersConfiguration({
        intl,
        formik,
        maxTotalAmount,
        paymentMethods
      }),
    [formik, intl, maxTotalAmount, paymentMethods]
  );

  const getComponentFilter = (targetFilter) =>
    completeConfiguration.find((filter) => filter.value === targetFilter)
      .component;

  const getOptionsToSelect = () =>
    completeConfiguration.map(({ component, ...filter }) => filter);

  return {
    completeConfiguration,
    getComponentFilter,
    getOptionsToSelect
  };
};
